"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const YoutubeEmbed = ({ embedId }) => (react_1.default.createElement("div", { className: "video-responsive" },
    react_1.default.createElement("iframe", { width: "853", height: "480", src: `https://www.youtube.com/embed/${embedId}`, frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, title: "Embedded youtube" })));
YoutubeEmbed.propTypes = {
    embedId: prop_types_1.default.string.isRequired
};
exports.default = YoutubeEmbed;
